// extracted by mini-css-extract-plugin
export default {"form-card":"Common_form-card__HXXJW","form-title":"Common_form-title__PvlB8","form-actions":"Common_form-actions__hKm9p"};